var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.cssVars),attrs:{"id":"playerContainer"}},[_c('player-component',{attrs:{"playerData":_vm.nowInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }